import  { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { singletonHook } from 'react-singleton-hook'
import * as HierarchyActions from '../redux/actions/HierarchyAction'
import { HideSpinner, ShowSpinner } from '../redux/actions/SpinnerAction'
import { ErrorToast } from '../redux/actions/ToasterAction';

import { useLocationServices } from './useLocationServices'

import { GetAvailableBedCapacity, GetTotalBedCapacity } from '../utilities/Helper'
import { GetAllParents, GetBuildings, GetTreeNode } from '../utilities/TreeHelper'
import { GetFilteredParentTypes, GetNodesByType, SearchTree, TreeNodeTypes } from '../constants/ProConstants'
import _ from 'lodash'


let hierarchyData = {data: {}, actions: {}}
const useHierarchyServiceFn = ()=>{
    const {locations} = useLocationServices();
   
  
    const tree = useSelector((state)=>{
        return state.hierarchy.allTree;
    })

    const activeTree = useSelector((state)=>{
        return state.hierarchy.activeTree;
    })
    const currentLocation = useSelector((state)=>{
        return state.hierarchy.currentLocation;
    })

    const selectedTreeNode = useSelector((state)=>{
        return state.hierarchy.selectedTreeNode 
    })

    const parentsInHierarchy = useSelector((state)=>{
        return state.hierarchy.parentsInHierarchy;
    })

    const buildings = useSelector((state)=>{
        return state.hierarchy.buildings;
    })

    const parentTypes = useSelector((state)=>{
        return state.hierarchy.parentTypes;
    })

    const parents = useSelector((state)=>{
        return state.hierarchy.parents;
    })

    const rooms = useSelector((state)=>{
        return state.hierarchy.rooms;
    })

    const beds = useSelector((state)=>{
        return state.hierarchy.beds;
    })

    const selectedType = useSelector((state)=>{
        return state.hierarchy.levelType;
    })

    const filteredLevelTypes = useSelector((state)=>{
        return state.hierarchy.filteredLevelTypes;
    })

    const locationChangeDetail = useSelector((state)=>{
        return state.hierarchy.locationChangeDetail;
    })

    const expandedKeys = useSelector((state)=>{
        return state.hierarchy.expandedKeys;
    })

    const totalBeds = useSelector((state)=>{
        return state.hierarchy.totalBeds;
    })

    const availableBeds = useSelector((state)=>{
        return state.hierarchy.availableBeds;
    })


    const dispatchHierarchy = useDispatch();

    const GetMultipleLocationTreeWithFilter = useCallback(async(filter, isFilterApplied = false)=>{
        try{
            dispatchHierarchy(ShowSpinner());  
            var action = await  HierarchyActions.GetMultipleLocationTreeWithFilter(filter);
            dispatchHierarchy(HideSpinner());
            dispatchHierarchy(action); 
            return action.tree; 
        }
        catch(err){
            dispatchHierarchy(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }     
    }, [dispatchHierarchy])

    const SetActiveTree= useCallback((tree)=>{      
        var action =  HierarchyActions.SetActiveTree(tree);       
        dispatchHierarchy(action);   
 
     }, [dispatchHierarchy])

     const SetExpandedKeys = useCallback((index, expandedKeys)=>{
         var action = HierarchyActions.SetExpandedKeys(index,expandedKeys);
         dispatchHierarchy(action);
     }, [dispatchHierarchy])

     const RefreshTree = useCallback(async (filter = null) => { 
         try{
            if(locationChangeDetail.length > 0)         {
                _.forEach(locationChangeDetail, async (id)=>{
                    var action = await  HierarchyActions.GetTreeByLocationId(id, filter);           
                    dispatchHierarchy(action); 
                })
            }
            else{
                var action = await  HierarchyActions.GetTreeByLocationId(currentLocation.id, filter);           
                dispatchHierarchy(action);  
            }  
        }
        catch(err){
            dispatchHierarchy(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }                 
       
    }, [dispatchHierarchy, currentLocation, locationChangeDetail])

     const SetCurrentLocation= useCallback((location)=>{      
        var action =  HierarchyActions.SetCurrentLocation(location);       
        dispatchHierarchy(action);   
 
     }, [dispatchHierarchy])

     const SetFilteredLevelTypes= useCallback((types)=>{      
        var action =  HierarchyActions.SetLevelTypes(types);       
        dispatchHierarchy(action);   
 
     }, [dispatchHierarchy])

    const SetParentsInHierarchy= useCallback((parentsInHierarchy)=>{      
        var action =  HierarchyActions.SetParentsInHierarchy(parentsInHierarchy);       
        dispatchHierarchy(action);   
 
     }, [dispatchHierarchy])

     const SetBuildings= useCallback((buildings)=>{      
        var action =  HierarchyActions.SetBuildings(buildings);       
        dispatchHierarchy(action);   
 
     }, [dispatchHierarchy])

    const SetParentTypes = useCallback((types)=>{      
        var action =  HierarchyActions.SetParentTypes(types);       
        dispatchHierarchy(action);   
 
     }, [dispatchHierarchy])
 
     const SetParents = useCallback((parents)=>{      
         var action =  HierarchyActions.SetParents(parents);       
         dispatchHierarchy(action);   
  
      }, [dispatchHierarchy])
 
     const SetRooms= useCallback((rooms)=>{      
         var action =  HierarchyActions.SetRooms(rooms);       
         dispatchHierarchy(action);   
  
      }, [dispatchHierarchy])
 
      const SetBeds= useCallback((beds)=>{      
         var action =  HierarchyActions.SetBeds(beds);       
         dispatchHierarchy(action);   
  
      }, [dispatchHierarchy])

      const OnTypeChanged= useCallback((type)=>{      
        var action =  HierarchyActions.SetType(type);       
        dispatchHierarchy(action);   
 
     }, [dispatchHierarchy])

     const SetSelectedTreeNode = useCallback((node)=>{

            var action = HierarchyActions.SelectedTreeNode(node);
            dispatchHierarchy(action);
            var locationId = _.isEqual(node.type, "LOCATION")?node.id: node.locationId; 
            var treeIndex = _.findIndex(tree, t=>_.isEqual(t.id, locationId))
            var locationIndex = _.findIndex(locations, l=>_.isEqual(l.id, locationId))
            if(treeIndex >= 0){
                SetActiveTree(tree[treeIndex])
            if(locationIndex >= 0){
                SetCurrentLocation(locations[locationIndex])
            }
          
         }      
     }, [dispatchHierarchy, SetCurrentLocation, SetActiveTree, tree,  locations])

     const SetSelectedTreeNodeByKey = useCallback((key)=>{
         let element = SearchTree(activeTree, "key", key)
         var action = HierarchyActions.SelectedTreeNode(element);
            dispatchHierarchy(action);

     }, [dispatchHierarchy, activeTree])

     const UpdateLocationChangeDetail = useCallback((changeDetail)=>{
        var action = HierarchyActions.SetLocationChangeDetail(changeDetail);
        dispatchHierarchy(action);

     }, [dispatchHierarchy])

    const ParseHierarchy = (includeSelf = false)=>{        
        if(_.isEmpty(selectedTreeNode))
            return;      
        const allBuildings = GetBuildings(activeTree); 
        const allParents =  includeSelf?[GetTreeNode(activeTree, selectedTreeNode.key), ...GetAllParents(activeTree, selectedTreeNode)]: GetAllParents(activeTree, selectedTreeNode);
        if(allParents.length === 0)
        return;                 
        const buildingData =  _.find(allParents, (o) => { return o.type === "BUILDING"; }) 
        if(_.isEmpty(buildingData))
        return;
      
        const types = GetFilteredParentTypes(activeTree, buildingData.key, selectedTreeNode.type)
        SetParentTypes(types)  
        let parentType = includeSelf?_.find(types, (o)=>{return o.key === selectedTreeNode.type}):_.find(types, (o)=>{return o.key === allParents[1].type})  
        if(_.isEmpty(parentType) && _.isEqual(selectedTreeNode.type, "ROOM")){
            parentType = _.find(types, (o)=>{return o.key === allParents[1].type})
        }
        let parents = [] 
         if(!_.isEmpty(parentType) && !_.isEqual(parentType.code, "BUILDING")){
            let nodeParents = GetNodesByType(SearchTree(activeTree, "key", buildingData.key), parentType.code);
            let self = GetNodesByType(selectedTreeNode, selectedTreeNode.type)        
                parents= includeSelf?_.uniqBy([...nodeParents, ...self],  "key")
                                    :nodeParents
                SetParents(parents); 
            } 
        const parent = _.intersectionBy(allParents, parents, 'key')
        const rooms = GetNodesByType(SearchTree(activeTree, "key", parent.length===1? parent[0].key : buildingData.key), "ROOM")
        const room = _.intersectionBy(allParents, rooms, "key")
        if(selectedTreeNode.type === "BED"){
            const beds = GetNodesByType(SearchTree(activeTree, "key", room[0].key), "BED", selectedTreeNode.key)
            SetBeds(_.filter(beds, (b)=> !b.assignmentId && b.active));
        }
        

        SetParentsInHierarchy(allParents);
        SetBuildings(allBuildings)            
        SetRooms(rooms); 
    }

    const FilterLevelTypes = (node)=>{ 
        switch(node.type){
            case "LOCATION":
                SetFilteredLevelTypes(TreeNodeTypes);
                break;
            case "BUILDING":               
                SetFilteredLevelTypes(TreeNodeTypes.filter(n=> !_.isEqual(n.code, node.type) && !_.includes(["BED"], n.code)))              
                break;
            case "WING": 
            case "UNIT":
            case "FLOOR":                    
                SetFilteredLevelTypes(TreeNodeTypes.filter(n=> !_.isEqual(n.code, node.type) && !_.includes(["BED", "BUILDING"], n.code)))
                break;
            case "ROOM":  
            case "BED":
                SetFilteredLevelTypes(TreeNodeTypes.filter(n=> _.isEqual(n.code, "BED")))
                break;   
            default:
                SetFilteredLevelTypes(TreeNodeTypes);
                break;
        }
    }



    const OnBuildingChanged = (building, type = null)=>{       
        const types = GetFilteredParentTypes(activeTree, building.key, !!selectedTreeNode?selectedTreeNode.type : type)
        const rooms = _.filter(GetNodesByType(SearchTree(activeTree, "key", building.key), "ROOM"), (n)=>_.isEqual(n.parentId, building.key))
        SetParentTypes(!!type?_.filter(types,(t)=>t.code !== type) : types);
        SetRooms(rooms);
        SetParents([]);
        SetBeds([]);   
    }

    const OnParentTypeChanged = (parentType, buildingKey)=>{
        if(!_.isNull(parentType) && !_.isEqual(parentType.code, "BUILDING")){
            const parents = GetNodesByType(SearchTree(activeTree, "key", buildingKey), parentType.code, "");//!!selectedTreeNode?selectedTreeNode.key : "") 
            SetParents(parents);
            SetRooms([])
            SetBeds([]);   
        }
        else{
            const rooms = _.filter(GetNodesByType(SearchTree(activeTree, "key", buildingKey), "ROOM"), (n)=>_.isEqual(n.parentId, buildingKey)) 
            SetRooms(rooms);
            SetParents([]);
            SetBeds([]); 
        }

    }

    const OnParentChanged = (parent)=>{
        const rooms = GetNodesByType(SearchTree(activeTree, "key", parent.key), "ROOM")
        SetRooms(rooms);
    }

    const OnRoomChanged = (room)=>{       
        const beds = GetNodesByType(SearchTree(activeTree, "key", room.key), "BED", !!selectedTreeNode?selectedTreeNode.key : "");       
        SetBeds(_.filter(beds, (b)=> !b.assignmentId && b.active));
    }

    const SetTotalBeds = useCallback((totalBeds)=>{
        var action = HierarchyActions.SetTotalBeds(totalBeds);
        dispatchHierarchy(action);
    }, [dispatchHierarchy])

    const SetAvailableBeds = useCallback((availableBeds)=>{
        var action = HierarchyActions.SetAvailableBeds(availableBeds);
        dispatchHierarchy(action)

    }, [dispatchHierarchy])
  

    useEffect(()=>{        
        if(!_.isEmpty(activeTree)){     
            SetBuildings(GetBuildings(activeTree))
        }
        SetParentTypes([])
        SetParents([]); 
        SetRooms([]); 
        SetBeds([]);       
    }, [activeTree, SetBuildings, SetParentTypes, SetParents, SetRooms, SetBeds, SetActiveTree])
    
    useEffect(()=>{
        let availableBeds = 0;
        let totalBeds = 0;
        _.forEach(tree, (t)=>{
            availableBeds+=GetAvailableBedCapacity(t);
            totalBeds+=GetTotalBedCapacity(t)
        })
        SetTotalBeds(totalBeds);
        SetAvailableBeds(availableBeds);      

    }, [tree])


     hierarchyData = {data:{tree, activeTree, selectedTreeNode, expandedKeys, currentLocation, parentsInHierarchy,filteredLevelTypes, buildings, parentTypes, parents, rooms, beds, selectedType, totalBeds, availableBeds},
                     actions:{GetMultipleLocationTreeWithFilter, SetExpandedKeys, SetCurrentLocation, RefreshTree, ParseHierarchy, FilterLevelTypes, SetFilteredLevelTypes, OnBuildingChanged, OnParentTypeChanged, OnParentChanged, OnRoomChanged, OnTypeChanged, SetSelectedTreeNode, SetSelectedTreeNodeByKey, SetParentTypes, UpdateLocationChangeDetail}}
     return hierarchyData;

}

export const useHierarchyService  = singletonHook(hierarchyData, useHierarchyServiceFn);